import * as React from "react";
import { Layout } from "../../layout";
import { CloudAccountList } from "./list";
import { Routes, Route } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { selectOrg } from "../../store/contextSlice";
import { CloudAccountCreateInitializer } from "./create/initializer";
import { CloudAccountDetailInitializer } from "./detailInitializer";

const CloudAccountRoute: React.FC = () => {
  const org = useAppSelector(selectOrg);

  return (
    <Layout key={org}>
      <Routes>
        <Route index element={<CloudAccountList />} />
        <Route path={`-create/*`} element={<CloudAccountCreateInitializer />} />
        <Route path={`:cloudaccount/*`} element={<CloudAccountDetailInitializer />} />
      </Routes>
    </Layout>
  );
};

export default CloudAccountRoute;
